import styled, { css } from 'styled-components'

import FormSubmitButton from '../../form/FormSubmitButton'
import FormFieldEmail from '../../form/fields/FormFieldEmail'
import FormFieldInput from '../../form/fields/FormFieldInput'
import FormFieldSelect from '../../form/fields/FormFieldSelect'
import FormikForm from '../../form/FormikForm'
import { Label as FormFieldInputLabel } from '../../form/fields/FormFieldInput/styled'
import {
  Label as FormFieldSelectLabel,
  MainWrapper,
} from '../../form/fields/FormFieldSelect/styled'
import { mq, sizes } from '../../theme'
import FormFieldCheckbox from '../../form/fields/FormFieldCheckbox'
import FormFieldPhone from '../../form/fields/FormFieldPhone'
import FormFieldTextArea from '../../form/fields/FormFieldTextArea'

const LabelStyle = css`
  label {
    ${({ theme }) => theme.textStyles.firaSansLg};
    white-space: nowrap;
  }
`

const SelectFieldStyle = css`
  ${FormFieldSelectLabel} {
    ${({ theme }) => theme.breakpoints.up('mobile')} {
      width: 15rem;
    }
    ${({ theme }) => theme.breakpoints.up('tablet')} {
      width: auto;
    }
  }

  ${MainWrapper} {
    width: 100%;
  }
`

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.brownBack};
  padding: 3rem;

  .FormLabel {
    ${({ theme }) => theme.breakpoints.up('mobile')} {
      margin-bottom: 0;
    }
  }
`

export const Title = styled.h3`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 4rem;
  margin-top: 0;
`

export const RequestAccessTitle = styled.h4`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 1.2rem;
  margin-top: 2.7rem;
`

export const RequestAccessText = styled.p`
  ${({ theme }) => theme.textStyles.montserratSm};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  margin-top: 1.6rem;
`

export const Form = styled(FormikForm)`
  width: 100%;
`

export const Fields = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 3rem;

  @media ${mq(sizes.tablet)} {
    gap: 3rem;
  }
`

export const NameField = styled(FormFieldInput)`
  ${FormFieldInputLabel} {
    ${({ theme }) => theme.breakpoints.up('mobile')} {
      width: 15rem;
    }
    ${({ theme }) => theme.breakpoints.up('tablet')} {
      width: auto;
    }
  }
`
export const EmailField = styled(FormFieldEmail)`
  ${({ theme }) => theme.breakpoints.up('tablet')} {
    gap: 3rem;
  }
  ${FormFieldInputLabel} {
    ${({ theme }) => theme.breakpoints.up('mobile')} {
      width: 15rem;
    }
    ${({ theme }) => theme.breakpoints.up('tablet')} {
      width: auto;
    }
  }
`
export const TextField = styled(FormFieldInput)`
  ${LabelStyle};
  ${FormFieldInputLabel} {
    ${({ theme }) => theme.breakpoints.up('mobile')} {
      width: 15rem;
    }
    ${({ theme }) => theme.breakpoints.up('tablet')} {
      width: auto;
    }
  }
`

export const SelectField = styled(FormFieldSelect)`
  ${SelectFieldStyle};
`

export const SelectFieldProfile = styled(FormFieldSelect)`
  ${({ theme }) => theme.breakpoints.up('tablet')} {
    gap: 3.2rem;
  }
  ${SelectFieldStyle};
`

export const SelectFieldSpeciality = styled(FormFieldSelect)`
  ${({ theme }) => theme.breakpoints.up('tablet')} {
    gap: 4.8rem;
  }
  ${SelectFieldStyle};
`

export const RequestAccessFormBlock = styled.div`
  margin-top: 1.8rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
`

export const CheckboxField = styled(FormFieldCheckbox)`
  p {
    color: ${({ theme }) => theme.colors.taupeGray};
  }
`

export const PhoneField = styled(FormFieldPhone)`
  ${LabelStyle};
`

export const TextareaField = styled(FormFieldTextArea)`
  ${LabelStyle};
`

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media ${mq(sizes.tablet)} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 5rem;
  }

  @media ${mq(sizes.desktop)} {
    grid-column-gap: 10rem;
  }
`

export const Group2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  max-width: 70.5rem;

  @media ${mq(sizes.tablet)} {
    gap: 5rem;
    align-items: center;
    flex-direction: row;

    > div {
      width: 50%;
    }
  }

  @media ${mq(sizes.desktop)} {
    gap: 10rem;
  }
`

export const Group3 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media ${mq(sizes.tablet)} {
    gap: 3rem;
    align-items: center;
    flex-direction: row;

    > div {
      width: 30%;
    }
  }

  @media ${mq(sizes.desktop)} {
    gap: 10rem;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin: 2rem auto 0 auto;
`

export const Success = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBaseBold};
  color: ${({ theme }) => theme.colors.arapawa};
`

export const SubmitButton = styled(FormSubmitButton)``
